import { isDesktopDevice, macOS } from '../../common/utils/browserDetect';
import axios from '../../common/utils/interceptor';
import { apiUrls } from '../../constants';
import { getStore } from '../../store';
import { ProctoringConfig } from '../interfaces/candidateConsent';

export const getProctoringConfig = (): ProctoringConfig | null | undefined => {
  let projectId = null;
  const workflowSession = getStore().state.workflowSession;
  if (workflowSession) {
    try {
      projectId = workflowSession.projectId;
    } catch (error) {
      console.error('Fetch project ID error: ', error);
    }
  }
  if (projectId) {
    const proctoringDetails = localStorage.getItem(String(projectId));
    if (proctoringDetails) return JSON.parse(proctoringDetails);
  }
  return null;
};

export const proctoringEnabled = (): boolean => {
  const proctoringSettings = getProctoringConfig();
  if (proctoringSettings) {
    const { offFocus, copyPaste, printScreen, multiFaceDetection, periodicSnapshot } = proctoringSettings;
    return offFocus || copyPaste || printScreen || multiFaceDetection || periodicSnapshot;
  }
  return false;
};

export const storeProctoringConfig = async (): Promise<void> => {
  try {
    let projectId = null;
    const workflowSession = getStore().state.workflowSession;
    if (workflowSession) {
      try {
        projectId = workflowSession.projectId;
        localStorage.removeItem(String(projectId));
      } catch (error) {
        console.error('Fetch project ID error: ', error);
      }
    }
    const { data } = await axios.get(apiUrls.GET_PROCTORING_CONFIG_URL);
    if (data && projectId) {
      localStorage.setItem(String(projectId), JSON.stringify(data));
    }
  } catch (error) {
    console.error('Fetch proctoring error: ', error);
  }
};

export const showCandidateConsent = (): boolean => {
  const isProctoringEnabled = proctoringEnabled();

  if (isProctoringEnabled && macOS() && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) {
    return false;
  }
  if (isProctoringEnabled && isDesktopDevice()) {
    return true;
  }
  return false;
};
